
import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import { AllTransationsType } from '../../@types/allTransactionsType';
import URLConstants from 'constants/urlConstants';

type RecentTransactionsState = {
    isLoading: boolean;
    error: boolean;
    recentTransactions: AllTransationsType[];
}

const initialState: RecentTransactionsState = {
    isLoading: false,
    error: false,
    recentTransactions: [],
}

const slice = createSlice({
    name: 'recentTransactions',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET TRANSACTIONS
        getRecentTransactionsSuccess(state, action) {
            state.isLoading = false;
            state.recentTransactions = action.payload;
        },
    }
});

// Reducer
export default slice.reducer;


export function getRecentTransactions(page: number, noOfRecords:number) {
    var params = {
        'noOfRecords':noOfRecords,
      }
    return async () => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get(`https://6jfjr9vffh.execute-api.ap-south-1.amazonaws.com/staging/mcts/bo/transactions/all/${page}`,{params});
        dispatch(slice.actions.getRecentTransactionsSuccess(response.data.data));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  }